import { render, staticRenderFns } from "./houseType.vue?vue&type=template&id=2ba1ce91&scoped=true&"
import script from "./houseType.vue?vue&type=script&lang=js&"
export * from "./houseType.vue?vue&type=script&lang=js&"
import style0 from "./houseType.vue?vue&type=style&index=0&id=2ba1ce91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1ce91",
  null
  
)

export default component.exports